// extracted by mini-css-extract-plugin
export default {"incut":"J6QwTbei","mobile":"mobile","icon":"JeUUbnIa"};